export const DialogActionTypes = {
  OpenDialog: 'DIALOG_OPEN_DIALOG',
  CloseDialog: 'DIALOG_CLOSE_DIALOG',
};
